import { render, staticRenderFns } from "./PageReviewTeachingFeed.vue?vue&type=template&id=808dff48&"
import script from "./PageReviewTeachingFeed.vue?vue&type=script&lang=js&"
export * from "./PageReviewTeachingFeed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports